import React from "react";
import { startOfDay } from "date-fns";
import { OnboardDueDateCard } from "@aph/ui-lib-humanx";
import DatePicker from "@/components/Picker/Date";

interface DueDateProps {
  heading: any;
  description: any;
  bgIcon: any;
  ctaText: any;
  ctaClick: (date: Date) => void;
  ctaBelowText?: any;
  initialDate?: Date;
}

const initialData = {
  heading: {
    prefixText: (
      <span>
        <strong>Woah, you’re almost there!</strong>
      </span>
    ),
  },
  description: {
    prefixText: (
      <span>
        Let us know <strong>when you’re due</strong> so we can share personalised tools and tips about labour
      </span>
    ),
  },
  ctaText: "Next",
  ctaBelowText: "",
  initialDate: startOfDay(new Date()),
};

const DueDate: React.FC<DueDateProps> = (props) => {
  const {
    heading = initialData.heading,
    description = initialData.description,
    bgIcon,
    ctaText = initialData.ctaText,
    ctaClick,
    ctaBelowText = initialData.ctaBelowText,
    initialDate = initialData.initialDate,
  } = props;
  const [date, setDate] = React.useState<Date>();

  const handleSubmit = (): void => {
    if (ctaClick && typeof ctaClick === "function") {
      ctaClick(date);
    }
  };

  return (
    <>
      <OnboardDueDateCard
        titleText={heading}
        subTitleText={description}
        backgroundCard={bgIcon}
        middleSection={<DatePicker fullWidth={false} setDate={setDate} initialDate={initialDate} daysLimit={[, 280]} />}
        ctaText={ctaText}
        ctaClick={handleSubmit}
        ctaBelowText={ctaBelowText}
      />
    </>
  );
};

export default DueDate;
